import { createFileRoute } from "@tanstack/react-router";
import { Tv5Page } from "@/components/products/Tv5Page";
import { tv5Seo } from "@/lib/page-seo";

export const Route = createFileRoute("/products/inext-tv5")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => tv5Seo(loaderData?.href ?? "/products/inext-tv5"),
  component: Tv5Page,
});
